
import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useCoopConfig } from '../../../../components/content/coop-config.jsx';
import EntregasXProductorTable from "../../entregas-x-productor-table.jsx";
import getBackgroundColor from '../../../../utils/getBackgroundColor.js';
import getColor from '../../../../utils/getColor.js';
import insertIf from '../../../../utils/insertIf.js';
import SearchColumn from '../../../../components/search/search-column.jsx';
import env from '../../../../environment.js';
import Api from '../../../../api/global.service.js';
import { formatNumber } from '../../../../utils/formatNumber.js';
import transformWord from '../../../../utils/transformWord.js';
import Swal from 'sweetalert2';

const ModalAsignarLote = forwardRef(({
	title,
	loteData,
	selectedEntregas,
	setSelectedEntregas,
	handleClickDividirEntrega,
	handleGuardarEntregas
}, ref) => {

	const coopConfig = useCoopConfig();
	const isCafeOrPimienta = () => {
		return [env.productos.CAFE, env.productos.PIMIENTA].includes(+coopConfig?.config?.cooperativa?.producto?.id);
	};
	const [show, setShow] = useState(false);
	const [blocking, setBlocking] = useState(false);
	const [unidades, setUnidades] = useState('');
  const [volumen, setVolumen] = useState({
    total: 0,
    asignado: 0,
    por_asignar: 0,
  });

	const [entregaData, setEntregaData] = useState([]);
	const [originalEntregasData, setOriginalEntregasData] = useState([]);


	const id_ciclo = loteData?.id_ciclo || null;

	//To call outside
	useImperativeHandle(ref, () => ({
		show: showHandler,
		close: closeHandler,
		fetchEntregas: getAllEntregas
	}));

	useEffect(() => {
		if (coopConfig.hasAcopioUnitsExtra()) {
			setUnidades(coopConfig.acopioUnitsExtra()?.abreviacion);
			setVolumen({
				total: loteData?.lote_kgs_totales_extra,
				asignado: loteData?.lote_kgs_entregados_extra,
				por_asignar: loteData?.lote_kgs_por_entregar_extra,
			});
		} else {
			setUnidades(coopConfig.acopioUnits()?.abreviacion);
			setVolumen({
				total: loteData?.lote_kgs_totales,
				asignado: loteData?.lote_kgs_entregados,
				por_asignar: loteData?.lote_kgs_por_entregar,
			});
    }
	}, [coopConfig.config, loteData]);

	useEffect(() => {
		if(loteData != null && show){
			getAllEntregas();
		}
	}, [loteData, show]);


	const getAllEntregas = () => {
		setBlocking(true);
		Api.Acopio.search('entregas_por_productor', {
			filter: [
				{ column: 'id_ciclo', operator: '=', value: id_ciclo },
				{ column: 'peso_pendiente', operator: '>', value: 0 }
			],
		})
		.then((res) => {
			setEntregaData(res.data);
			setOriginalEntregasData(res.data);
		})
		.catch((err) => {
			console.error(err);
		})
		.finally(() => {
			setBlocking(false);
		});
	}

	const searchColumns = React.useMemo(
		() => [
		{ value: 0, target: '', label: 'TODO' },
		{ value: 1, target: 'fecha_acopio', label: 'FECHA ENTREGA' },
		{ value: 3, target: 'nombre_lote', label: 'FOLIO/LOTE' },
		...insertIf(!coopConfig.hasAcopioUnitsExtra(), {
			value: 4,
			target: 'peso_pendiente',
			label: `PESO DISPONIBLE (${coopConfig.acopioUnits()?.abreviacion})`,
		}),
		...insertIf(coopConfig.hasAcopioUnitsExtra(), {
			value: 4,
			target: 'peso_pendiente_extra',
			label: `PESO DISPONIBLE (${coopConfig.acopioUnitsExtra()?.abreviacion})`,
		}),
		{ value: 7, target: 'folio_acopio', label: 'FOLIO RECIBIDO' },
		{ value: 5, target: 'productor_clave_tx', label: 'CLAVE' },
		...insertIf(!!+coopConfig.config?.usa_codigo_tx, { value: 6, target: 'productor_codigo_tx', label: 'CÓDIGO' }),
		{ value: 8, target: 'productor_nombre', label: 'NOMBRE PRODUCTOR' },
		{ value: 9, target: 'localidad', label: 'LOCALIDAD' },
		{ value: 10, target: 'region', label: 'REGIÓN' },
		{ value: 11, target: 'centro_acopio', label: 'CENTRO DE ACOPIO' },
		{ value: 12, target: 'cuenta_categoria', label: 'CATEGORÍA PRODUCTOR' },

		...insertIf(isCafeOrPimienta(), {
			value: 2,
			target: 'tipo_cafe',
			label: 'TIPO DE ' + transformWord(coopConfig.config?.cooperativa?.producto?.nombre || 'café', ['uppercase']),
		}),
		...insertIf(isCafeOrPimienta(), { value: 2, target: 'proceso', label: 'PROCESO' }),
		...insertIf(coopConfig.mostrarTipo(), { value: 2, target: 'tipos_entregas', label: 'CATEGORÍA' }),
		...insertIf(coopConfig.mostrarCostalera(), { value: 2, target: 'nombre_cat_costaleras_estatus', label: 'COSTALERA' }),
		...insertIf(coopConfig.mostrarLote(), { value: 2, target: 'nombre_lote', label: 'LOTE' }),
		{ value: 13, target: 'no_bultos', label: 'Nº RECIPIENTES' },
		{ value: 14, target: 'peso_bruto', label: `PESO BRUTO (${coopConfig.acopioUnits()?.abreviacion})` },
		{ value: 15, target: 'peso_tara', label: `PESO TARA (${coopConfig.acopioUnits()?.abreviacion})` },
		...insertIf(coopConfig.mostrarDescuento() && !coopConfig.mostrarDescuentosPorcentaje(), {
			value: 16,
			target: 'peso_descuento',
			label: `PESO DESCUENTO${coopConfig.mostrarDescuentoHumedad() ? ' CALIDAD' : ''} (${coopConfig.acopioUnits()?.abreviacion})`,
		}),
		...insertIf(coopConfig.mostrarDescuento() && coopConfig.mostrarDescuentosPorcentaje(), {
			value: 17,
			target: 'peso_descuento_perc',
			label: `DESCUENTO${coopConfig.mostrarDescuentoHumedad() ? ' CALIDAD' : ''} (%)`,
		}),
		...insertIf(coopConfig.mostrarDescuentoHumedad() && !coopConfig.mostrarDescuentosPorcentaje(), {
			value: 18,
			target: 'peso_descuento_humedad',
			label: `PESO DESCUENTO HUMEDAD (${coopConfig.acopioUnits()?.abreviacion})`,
		}),
		...insertIf(coopConfig.mostrarDescuentoHumedad() && coopConfig.mostrarDescuentosPorcentaje(), {
			value: 19,
			target: 'peso_descuento_humedad_perc',
			label: `DESCUENTO HUMEDAD (%)`,
		}),
		{ value: 20, target: 'peso_neto', label: `PESO NETO (${coopConfig.acopioUnits()?.abreviacion})` },
		...insertIf(coopConfig.hasAcopioUnitsExtra(), {
			value: 21,
			target: 'peso_neto_extra',
			label: `PESO NETO (${coopConfig.acopioUnitsExtra()?.abreviacion})`,
		}),
		...insertIf(!coopConfig.hasAcopioUnitsExtra(), { value: 22, target: 'precio_por_kg', label: 'PRECIO A PRODUCTOR' }),
		...insertIf(coopConfig.hasAcopioUnitsExtra(), {
			value: 23,
			target: 'precio_por_kg_extra',
			label: `PRECIO A PRODUCTOR (${coopConfig.currency()?.symbol}/${coopConfig.acopioUnitsExtra()?.abreviacion})`,
		}),
		{ value: 24, target: 'importe_total', label: `IMPORTE TOTAL (${coopConfig.currency()?.symbol})` },
		{ value: 25, target: 'total_anticipos_recuperados', label: 'DESCUENTOS DEUDAS' },
		{ value: 26, target: 'pagado_a_productor', label: `PAGADO A PRODUCTOR (${coopConfig.currency()?.symbol})` },
		{ value: 27, target: 'total_saldo', label: `SALDO DE LA ENTREGA (${coopConfig.currency()?.symbol})` },
		{ value: 28, target: 'metodo_pago', label: 'MÉTODO DE PAGO' },
		],
		[coopConfig]
	);


	const showHandler = () => {
		setShow(true);
	}

	const closeHandler = async () => {
		if(selectedEntregas.length === 0 ){
			setShow(false);
			return	
		}

		const result = await Swal.fire({
			title: '¿Confirmas que quieres cerrar esta ventana?',
			text: "Las entregas seleccionadas aún no han sido asignadas al lote, si sales de este proceso tus cambios se perderán",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Confirmar',
			cancelButtonText: 'Cancelar'
		});
		
		if (result.isConfirmed) {
			setSelectedEntregas([]);
			setShow(false);
		}
		
	}

	const getKgsEntregasSeleccionadas = () => {
		if (coopConfig.hasAcopioUnitsExtra()) {
			return formatNumber(selectedEntregas?.reduce((acc, entrega) => acc + (Number(entrega?.peso_pendiente_extra) || 0), 0) || 0);
		} else {
			return formatNumber(selectedEntregas?.reduce((acc, entrega) => acc + (Number(entrega?.peso_pendiente) || 0), 0) || 0);
		}
	}


	const setDataFilter = data => {
    setEntregaData(data);
  };

	return (
		<div className="modal" style={{ display: (show) ? 'block' : 'none', backgroundColor: 'rgba(0,0,0,0.2)' }}>
			<div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
				<div className="modal-content">
					<div className="modal-header"
						style={{ flex: 'inherit' }}
					>
						<h4 className="modal-title">{title}</h4>
						<button onClick={() => closeHandler()} type="button" className="btn" style={{ borderRadius: '20px 20px 20px 20px' }}>
							<i className="fa fa-times"></i>
						</button>
					</div>
					<div className="modal-body">
						<div className="container-fluid">
							<div className="row pb-5 pt-4 container">
								<div className="col-md-4 ms-auto text-center col container">
									<p className='bold mb-0'>Volumen total</p>
									<p className='lead fw-bold'>{formatNumber(volumen?.total ?? 0)} {unidades}</p>
								</div>
								<div className="col-md-4 ms-auto text-center col container">
									<p className='bold mb-0'>Volumen por asignar</p>
									<p className='lead fw-bold'>{formatNumber(volumen?.por_asignar ?? 0)} {unidades}</p>
								</div>
								<div className="col-md-4 ms-auto text-center col container">
									<p className='bold mb-0'>Volumen de entregas seleccionadas</p>
									<p className='lead fw-bold'>{getKgsEntregasSeleccionadas()} {unidades}</p>
								</div>
							</div>
							<div className="row mb-2"
								style={{
									minHeight: '40px',
								}}
							>
								<p>
									<span className="entregas-titulo mr-1">ENTREGAS</span>
									<span className="entregas-subtitulo">Asigna o edita entregas a los lotes</span>
								</p>
							</div>
							<div className="row mb-2 d-flex align-items-center justify-content-center container">
								<div className="col-md-8 sm-auto">
									<SearchColumn
										data={originalEntregasData}
										columns={searchColumns}
										setDataFilter={evt => {
										setDataFilter(evt);
										}}></SearchColumn>
								</div>
								<div className="col-md-2 sm-auto mt-sm-0 mt-2">
									<button
										className="btn btn-outline-secondary btn-sirio pr-3"
										disabled={selectedEntregas?.length !== 1}
										style={{
											borderRadius: '20px',
											flexGrow: 1,
											flexBasis: 'auto',
											opacity: selectedEntregas?.length !== 1 ? 0.5 : 1,
											width: '100%',
										}}
										onClick={() => handleClickDividirEntrega()}
									>
										<i className="fa fa-edit"></i>Dividir entrega
									</button>
								</div>
								<div className="col-md-2 ms-auto mt-sm-0 mt-2">
									<button
										className="btn btn-sirio pr-3"
										style={{
											borderRadius: '20px',
											color: '#333',
											fontWeight: 'normal',
											fontSize: 16,
											flexGrow: 1,
											flexBasis: 'auto',
											// marginRight: '12px',
											width: '100%',
										}}
									onClick={() => handleGuardarEntregas()}
									>
										<i className="fa fa-plus"></i> Agregar a lote
									</button>
								</div>
							</div>
							<div className="row">
								<div className="col-12"
									style={{
										minHeight: '600px',
									}}
								>
									
								<EntregasXProductorTable
									blocking={blocking}
									selected="id"
									data={entregaData}
									fnBackgroundColor={getBackgroundColor}
									fnColor={getColor}
									coopConfig={coopConfig}
									selectedData={selectedEntregas || []}
									setSelectedData={setSelectedEntregas}
                  multiSelect
									isAsignarEntregas
								/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);

});

export default ModalAsignarLote;